"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translations = void 0;
exports.translations = {
    en: {
        h1: "What EZSpeech covers",
        features: {
            1: { title: "Oral-motor exercises", text: "23 exercises" },
            2: {
                title: "Sounds production and automation",
                text: "More that 200 practices",
            },
            3: { title: "Fine motor exercises", text: "6 exercises" },
            4: { title: "Speech Development", text: "More than 300 exercises" },
            5: {
                title: "Personified plan of care and goal settings",
                text: "3-5 per each exercise",
                popUpMessage: "Go to your patient's profile to select exercises for your patients",
            },
            6: {
                title: "Progress  monitoring",
                popUpMessage: "Go to your patient's profile to access their reports",
            },
        },
    },
    ru: {
        h1: "Что включает EZSpeech",
        features: {
            1: { title: "Артикуляционная гимнастика", text: "23 упражнений" },
            2: {
                title: "Отработка и автоматизация звуков",
                text: "Более 200 практик",
            },
            3: {
                title: "Упражнения на мелкую моторику",
                text: "6 упражнений",
            },
            4: { title: "Развитие речи", text: "Более 300 упражнений" },
            5: {
                title: "Индивидуальный план занятий и постановка целей",
                text: "3-5 для каждого упражнения",
                popUpMessage: "Для выбора упражнений зайдите в профиль своего пациента",
            },
            6: {
                title: "Мониторинг результатов",
                popUpMessage: "Для просмотра отчетов зайдите в профиль своего пациента",
            },
        },
    },
    uz: {
        h1: "EZSpeech nimani o'z ichiga oladi?",
        features: {
            1: { title: "Artikulyatsiya mashqlari", text: "23 ta mashq" },
            2: {
                title: "Tovushlarni o'qitish va avtomatlashtirish",
                text: "200 dan ortiq amaliyot",
            },
            3: {
                title: "Nozik vosita mashqlari",
                text: "6 ta mashq",
            },
            4: { title: "Nutqni rivojlantirish", text: "300 dan ortiq mashqlar" },
            5: {
                title: "Shahsiy dars rejasi va maqsadni belgilash",
                text: "Har bir mashq uchun 3-5",
                popUpMessage: "Mashqlarni tanlash uchun bemor profilingizga tashrif buyuring.",
            },
            6: {
                title: "Natijalarni kuzatish",
                popUpMessage: "Hisobotlarni ko'rish uchun bemor profilingizga tashrif buyuring",
            },
        },
    },
    kz: {
        h1: "EZSpeech құрамына не кіреді",
        features: {
            1: { title: "Артикуляциялық гимнастика", text: "23 жаттығу" },
            2: {
                title: "Дыбыстарды меңгеру және автоматтандыру",
                text: "200-ден астам практика",
            },
            3: {
                title: "Ұсақ моториканы дамыту жаттығулары",
                text: "6 жаттығу",
            },
            4: { title: "Сөйлеуді дамыту", text: "300-ден астам жаттығу" },
            5: {
                title: "Жеке жаттығу жоспары және мақсат қою",
                text: "Әр жаттығу үшін 3–5",
                popUpMessage: "Жаттығуларды таңдау үшін пациент профиліне кіріңіз",
            },
            6: {
                title: "Нәтижелерді бақылау",
                popUpMessage: "Есептерді көру үшін пациент профиліне кіріңіз",
            },
        },
    }
};
